import { defineMessages } from 'react-intl';

export default defineMessages({

    saveFailedMsg: {
        id: 'twia.commercial.buildingAdditionalInterest.contacts.policyroles.Save failed',
        defaultMessage: 'Save failed, please try again',
    },
    saveFailedTitle: {
        id: 'twia.commercial.buildingAdditionalInterest.contacts.policyroles.Cannot Add Premium Finance',
        defaultMessage: 'Cannot Add Premium Finance',
    },
    deleteFailedTitle: {
        id: 'twia.commercial.buildingAdditionalInterest.contacts.policyroles.Cannot Delete Premium Finance',
        defaultMessage: 'Cannot Delete Premium Finance',
    },
    cancel: {
        "id": "twia.commercial.buildingAdditionalInterest.Cancel",
        "defaultMessage": "Cancel"
    },
    removeAdditionalInterest: {
        "id": "twia.commercial.buildingAdditionalInterest.Remove Additional Interest",
        "defaultMessage": "Remove Additional Interest"
    },
    removeAddlInterestMessage: {
        "id": "twia.commercial.buildingAdditionalInterest.Are you sure you want to remove this contact?",
        "defaultMessage": "Are you sure you want to remove this contact?"
    },
    close: {
        "id": "twia.commercial.buildingAdditionalInterest.additionalInsured.Close",
        "defaultMessage": "Close"
    },
    contractofSale: {
        id: 'twia.commercial.translation.buildingAdditionalInterest.Contract of Sale',
        defaultMessage: 'Contract of Sale'
    },
    mortgagee: {
        id: 'twia.commercial.translation.buildingAdditionalInterest.Mortgagee',
        defaultMessage: 'Mortgagee'
    },
    lossPayee: {
        id: 'twia.commercial.translation.buildingAdditionalInterest.Loss Payee',
        defaultMessage: 'Loss Payee'
    },
});
